export default "__VITE_ASSET__DVZOXD$S__"